import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserStateService } from '../services/user-state/user-state';

/**
 * Guard that redirects authenticated users away from login page
 * Prevents logged-in users from accessing the login screen
 */
export const loginGuard: CanActivateFn = () => {
  const userStateService = inject(UserStateService);
  const router = inject(Router);
  
  if (userStateService.isUserLoaded()) {
    router.navigate(['/']);
    return false;
  }

  return true;
};

